module.exports = __webpack_public_path__ + "img/Guaranteed.19e29a54.png";